import React, { useEffect, useState } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Divider, IconButton, ListItemButton, Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import DrawIcon from '@mui/icons-material/Draw';
import FileSelectorDialog from '../../common/forms/FileSelectorDialog';
import { jwtDecode } from "jwt-decode";
import { useUploadSignature } from '../../../hooks/uploads/useUploadSignature';

export default function Signature() {
    const { t } = useTranslation('common'); 
    const [open, setOpen] = React.useState(false);
    const { showSnackbar } = useSnackbar();
    const baseApiUrl = process.env.REACT_APP_API_URL;
    const publicUploadsFolder = "public_uploads";
    const token = localStorage.getItem("accessToken");
    const userId = jwtDecode(token).id;

    const [imgSrc, setImgSrc] = useState("");

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };

    const [fileSelectorDialogOpen, setFileSelectorDialogOpen] = React.useState(false);
    const onFileSelectorClose = () => {
        setFileSelectorDialogOpen(false);
    };

    const [trigger, setTrigger] = React.useState(false);
    // Toggle function
    const toggleTrigger = () => {
        setTrigger(prev => !prev);
    };

    const onFileUploadSuccess = () => {
        showSnackbar(t('files.messages.upload_success'), "success");
        setFileSelectorDialogOpen(false);
        toggleTrigger();
    };

    const { upload, progress } = useUploadSignature(onFileUploadSuccess);

    const handleUploadPicture = async (file) => {
        const formData = new FormData();
        formData.append("sign", file);
        try {
            await upload(formData);
        } catch (error) {
            if (error.status === 415)
            {
                showSnackbar(t("files.messages.unsupported_file_type"), "error");
            }
            else if (error.status === 413)
            {
                showSnackbar(t("files.messages.file_too_large"), "error");
            }
            else {
                showSnackbar(t("files.messages.upload_failed"), "error");
            }
        }
    };

    useEffect(() => {
        const bustCache = Date.now(); // unique value each time
        setImgSrc(`${baseApiUrl}/${publicUploadsFolder}/sign-${userId}.png?${bustCache}`);
    }, [trigger]);

    return (
        <React.Fragment>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <DrawIcon fontSize='large' color='secondary'/>
            </ListItemIcon>
            <ListItemText 
                primary="Signature"
                secondary="view and upload your signature"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
            Your Signature
            </DialogTitle>
            <DialogContent>
                <Box
                    component="img"
                    src={imgSrc}
                    alt="sign"
                    sx={{
                        width: "100%",       // fills container width
                        maxWidth: 500,       // but never exceeds 500px
                        display: "block",    // removes inline spacing
                        margin: "0 auto"     // optional: center horizontally
                    }}
                    onError={(e) => {
                        e.currentTarget.src = "/images/sign-0.png";
                    }}
                />
                <Button
                    onClick={() => setFileSelectorDialogOpen(true)}
                    variant="outlined"
                    component="label"
                    fullWidth
                >
                    Upload Signature
                </Button>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        <FileSelectorDialog 
            fileType='image'
            open={fileSelectorDialogOpen}
            onClose={onFileSelectorClose}
            onSubmit={handleUploadPicture}
            progress={progress}
            showRecordVoice={false}
        />
        </React.Fragment>
    );
}